// utils
import { getLoginRole } from "utils/login";

// access
import userPageAccess from "routes/pageAccess.js";

export const hasRouteAccess = routeURL => {
  let url, roleRoutes;
  const roleInfo = getLoginRole();

  if (typeof routeURL === "string" && routeURL !== "/")
    url = routeURL.replace(/^\/|\/$/g, "");
  else
    url = routeURL;

  roleRoutes = userPageAccess.find(item => item.role === roleInfo.roleName);
  return (roleRoutes ? roleRoutes.route.includes(url) : false);
}
